import { Outlet } from 'react-router-dom';
import SimpleHeader from './simple-header';

export default function SimpleBaseAppLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      <SimpleHeader />
      <main className="flex-grow px-4">
        <Outlet />
      </main>
    </div>
  );
}
